(function() {
	'use strict';
	angular.module('FYN').controller('TermsOfUseController', function($scope, $http) {
		
	});
})();
